import {
  CommonConfigComponent,
  IWidgetComponentProps,
  RichTextAdvancedInput,
  getWidgetProps,
} from '@framework/engine';
import { FormItem, MenuPresets, TextInput } from '@framework/form';
import { Divider } from 'antd';
import * as React from 'react';
import { IEmailVerificationWidget } from './IEmailVerificationWidget';

export interface IEmailVerificationWidgetConfigComponentProps
  extends IWidgetComponentProps<IEmailVerificationWidget> {}

export function EmailVerificationWidgetConfigComponent(
  props: IEmailVerificationWidgetConfigComponentProps,
) {
  const options = getWidgetProps(props);
  return (
    <div>
      {/* Configurazioni comuni */}
      <CommonConfigComponent {...props} noConfirmation hideConfigHelpText />

      {/* Configurazione testi prima fase */}
      <Divider orientation="left" orientationMargin={0}>
        1 | Avvio verifica
      </Divider>
      <FormItem name="layout.startButtonText" label="Testo pulsante iniziale">
        <TextInput name="layout.startButtonText" />
      </FormItem>
      <FormItem name="layout.startHelpText" label="Testo di aiuto iniziale">
        <RichTextAdvancedInput
          name="layout.startHelpText"
          menus={MenuPresets.Minimal}
          rows={3}
        />
      </FormItem>

      {/* Configurazione testi seconda fase */}
      <Divider orientation="left" orientationMargin={0}>
        2 | Controllo validità
      </Divider>
      <FormItem name="layout.endButtonText" label="Testo pulsante verifica">
        <TextInput name="layout.endButtonText" />
      </FormItem>
      <FormItem name="layout.endHelpText" label="Testo di aiuto verifica">
        <RichTextAdvancedInput
          name="layout.endHelpText"
          menus={MenuPresets.Minimal}
          rows={3}
        />
      </FormItem>
    </div>
  );
}
